import { createCustomEnum } from "./customEnum";

const BillToTypes = createCustomEnum({
	none: {
		value: 0,
		name: "none",
		displayName: "None",
	},
	merchant: {
		value: 1,
		name: "merchant",
		displayName: "Merchant",
	},
	agent: {
		value: 2,
		name: "agent",
		displayName: "Agent",
	},
	aurora: {
		value: 3,
		name: "aurora",
		displayName: "Aurora",
	},
});

export default BillToTypes;
